export default __webpack_public_path__ + "static/media/AmericanExpress.b1445d4f.svg";